/**
 * The message a new team member receives.
 *
 * One wording for both ways it can reach them: e-mailed by the panel
 * (functions/api/send-invite.js), or sent by the owner from their own mail app
 * or WhatsApp when automatic e-mail is not set up (TeamPage). Plain JS with no
 * imports, so the Cloudflare Function can bundle it too.
 */

const ROLE_LABELS = { owner: 'Owner', manager: 'Manager', staff: 'Staff' }

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
]

// Spelled out rather than toLocaleDateString, which renders differently in
// each browser and in the Workers runtime.
const longDate = (value) => {
  const d = new Date(value)
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`
}

/**
 * Opens the panel on the Register tab with their address filled in. The link
 * carries no secret: access comes from the invitation stored against the
 * address, so the link is only a convenience.
 */
export const inviteLink = (origin, email) => `${origin}/?invite=${encodeURIComponent(email)}`

export function inviteMessage({ origin, email, role, expiresAt, invitedBy }) {
  const link = inviteLink(origin, email)
  const subject = "You're invited to the Coquis Store Manager"
  const body = [
    'Hi,',
    '',
    `${invitedBy || 'The shop owner'} has given you ${ROLE_LABELS[role] ?? role} access to the Coquis Store Manager, where the shop's products, orders and invoices are managed.`,
    '',
    `To get started, open this link and create your account with this e-mail address (${email}):`,
    link,
    '',
    'Already have a Coquis account with this address? Sign in with it instead.',
    '',
    `This invitation expires on ${longDate(expiresAt)}.`,
    '',
    "Coquis Men's Outfitters",
  ].join('\n')
  return { subject, body, link }
}
